// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMWhatsNew.tsx — PropelMapper feature-callout popover.
//
// A small "New" badge that opens a popover announcing a recently-added feature:
// eyebrow (sparkle + "New"), title, body, and dismiss / take-a-look actions.
// Reusable wherever you call out a new feature (a sidebar item, a toolbar button,
// a menu entry) — it is NOT specific to any one page.
//
// Controlled or uncontrolled: omit `open`/`onOpenChange` to let it self-manage.
// Anchors the popover to the badge; `placement` picks the side.
//
//   <PMWhatsNew title="Metrics Dashboard"
//     body="See visit volume, sync health, and team activity in one place."
//     onExplore={() => go('/metrics')} onDismiss={() => markSeen('metrics')} />

const PMWHATS_CSS = `
.pmwn{position:relative;display:inline-flex}
.pmwn-badge{font:700 11px/1 var(--pm-font-sans);letter-spacing:.05em;color:var(--pm-primary-dark);background:var(--pm-primary-surface);border:1px solid transparent;border-radius:var(--pm-radius-pill,999px);padding:3px 11px;cursor:pointer}
.pmwn-badge:hover{background:var(--pm-primary-light);border-color:var(--pm-primary-light)}
.pmwn-badge:focus-visible{outline:none;box-shadow:var(--pm-focus-ring)}
.pmwn-badge.on-dark{color:#9BDA99;background:rgba(155,218,153,.16)}
.pmwn-badge.on-dark:hover{background:rgba(155,218,153,.28);border-color:rgba(155,218,153,.45)}
.pmwn-pop{position:absolute;z-index:60;width:268px;background:var(--pm-surface);color:var(--pm-fg-1);border:1px solid var(--pm-border-light);border-radius:14px;box-shadow:var(--pm-shadow-l,0 14px 34px rgba(0,0,0,.3));padding:15px 16px 14px;animation:pmwnIn .16s ease-out}
.pmwn-pop.place-bottom{top:calc(100% + 8px);left:0}
.pmwn-pop.place-top{bottom:calc(100% + 8px);left:0}
.pmwn-pop.place-right{top:0;left:calc(100% + 8px)}
.pmwn-pop.place-left{top:0;right:calc(100% + 8px)}
@keyframes pmwnIn{from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:none}}
@media (prefers-reduced-motion: reduce){.pmwn-pop{animation:none}}
.pmwn-arrow{position:absolute;width:11px;height:11px;background:var(--pm-surface);border:1px solid var(--pm-border-light);transform:rotate(45deg)}
.pmwn-pop.place-bottom .pmwn-arrow{top:-6px;left:24px;border-right:none;border-bottom:none}
.pmwn-pop.place-top .pmwn-arrow{bottom:-6px;left:24px;border-left:none;border-top:none}
.pmwn-eyebrow{display:inline-flex;align-items:center;gap:5px;font:700 11px/1 var(--pm-font-sans);letter-spacing:.05em;text-transform:uppercase;color:var(--pm-primary);margin-bottom:7px}
.pmwn-eyebrow .pmwn-ico{width:15px;height:15px;display:inline-flex;color:currentColor}
.pmwn-eyebrow .pmwn-ico svg{display:block;width:100%;height:100%}
.pmwn-title{font:var(--pm-headline-s);margin:0 0 5px;color:var(--pm-fg-1)}
.pmwn-body{font:var(--pm-body-s);color:var(--pm-fg-2);line-height:1.5;margin:0 0 14px;text-wrap:pretty}
.pmwn-acts{display:flex;gap:8px;justify-content:flex-end}
.pmwn-btn{font-family:inherit;cursor:pointer;border-radius:var(--pm-radius-pill,999px);font:600 13px/1 var(--pm-font-sans);padding:8px 16px;border:none;min-height:38px}
.pmwn-btn.ghost{background:transparent;color:var(--pm-fg-2)}
.pmwn-btn.ghost:hover{background:var(--pm-surface-variant)}
.pmwn-btn.go{background:var(--pm-primary);color:#fff}
.pmwn-btn.go:hover{background:var(--pm-primary-dark)}
.pmwn-btn:focus-visible{outline:none;box-shadow:var(--pm-focus-ring)}
`;

function pmwnEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmwhatsnew-css")) return;
  const s = document.createElement("style"); s.id = "pmwhatsnew-css"; s.textContent = PMWHATS_CSS;
  document.head.appendChild(s);
}

function PMWnSparkle() {
  const I = (typeof window !== "undefined" && (window as any).PM_ICONS) || {};
  const svg = I["sparkle"] || I["sparkle-outline"] || I["star"] || I["star-outline"] || I["auto-awesome"] || null;
  if (svg) return <span className="pmwn-ico" aria-hidden="true" style={{ ["--icon-fg" as any]: "currentColor" }} dangerouslySetInnerHTML={{ __html: svg }} />;
  return <span className="pmwn-ico" aria-hidden="true" style={{ fontWeight: 700 }}>✦</span>;
}

export function PMWhatsNew({
  label = "New",
  title,
  body,
  open,
  onOpenChange,
  onExplore,
  onDismiss,
  exploreLabel = "Take a look",
  dismissLabel = "Dismiss",
  placement = "bottom",
  dark = false,
  className = "",
  style = {},
}: any) {
  pmwnEnsureCSS();
  const R = React as any;
  const controlled = open != null;
  const [internalOpen, setInternalOpen] = R.useState(false);
  const isOpen = controlled ? open : internalOpen;
  const wrapRef = R.useRef(null);

  const setOpen = (v: boolean) => { if (!controlled) setInternalOpen(v); if (onOpenChange) onOpenChange(v); };

  R.useEffect(() => {
    if (!isOpen) return;
    const onDoc = (e: any) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false); };
    const onKey = (e: any) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => { document.removeEventListener("mousedown", onDoc); document.removeEventListener("keydown", onKey); };
  }, [isOpen]);

  return (
    <span className={"pmwn" + (className ? " " + className : "")} style={style} ref={wrapRef}>
      <button
        type="button"
        className={"pmwn-badge" + (dark ? " on-dark" : "")}
        aria-haspopup="dialog"
        aria-expanded={isOpen}
        onClick={() => setOpen(!isOpen)}
      >
        {label}
      </button>
      {isOpen ? (
        <div className={"pmwn-pop place-" + placement} role="dialog" aria-label={title || "What's new"}>
          {(placement === "bottom" || placement === "top") ? <span className="pmwn-arrow" /> : null}
          <div className="pmwn-eyebrow"><PMWnSparkle />New</div>
          {title ? <h4 className="pmwn-title">{title}</h4> : null}
          {body ? <p className="pmwn-body">{body}</p> : null}
          <div className="pmwn-acts">
            <button type="button" className="pmwn-btn ghost" onClick={() => { setOpen(false); if (onDismiss) onDismiss(); }}>{dismissLabel}</button>
            <button type="button" className="pmwn-btn go" onClick={() => { setOpen(false); if (onExplore) onExplore(); }}>{exploreLabel}</button>
          </div>
        </div>
      ) : null}
    </span>
  );
}
